const domain: string = 'NEWS'

export const SAVE_NEWS: string = `${domain}/SAVE_NEWS`
export const SET_LOADING_NEWS: string = `${domain}/SET_LOADING_NEWS`
